import { useQuery } from '@tanstack/react-query';

// helper
import { BaseError } from '../../helpers/BaseError';

// models
import { AllUsers, AudienceDetailModel } from '../../models/audience.model';

// services
import API from '../../services/api';

import { queryClient } from '../../AppComposer';
// query keys
import audienceKeys from './_queryKeys';

const getAudience = async (): Promise<AudienceDetailModel[]> => {
    const { data } = await API.getAudiencesDetail();
    return [...data].reverse().concat(AllUsers);
};

export default function useAudiencesDetailQuery() {
    return useQuery<AudienceDetailModel[], BaseError>({
        queryKey: audienceKeys.audiencesDetail,
        queryFn: () => getAudience(),
        staleTime: 60 * 60,
    });
}

export const getCachedAudiencesDetail = () =>
    queryClient.getQueryData(
        audienceKeys.audiencesDetail,
    ) as AudienceDetailModel[];
